<template>
  <span>{{ section.shortName || section.name }}</span>
</template>
<script>
import gql from "fraql";
export default {
  name: "AppShowSection",
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  fragments: {
    sectionFields: gql`
      fragment _ on Section {
        name
        shortName
      }
    `
  }
};
</script>
